// extracted by mini-css-extract-plugin
export default {"solidIcon":"Card_solidIcon__7fDg+","locateAnAire":"Card_locateAnAire__wlyXY","title":"Card_title__qr0vL","card":"Card_card__7Eml9"};